import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
     name: 'translate',
})
export class TranslatePipe implements PipeTransform {
     transform(value: any, args?: any): any {
          return window.appLang[value] || value;
     }
}
